const constants = Object.freeze({
  REDIRECT_TO_SUBSCRIPTION: 'REDIRECT_TO_SUBSCRIPTION',

  ALERT_SUBSCRIPTION_ENDS: 'ALERT_SUBSCRIPTION_ENDS',
  ALERT_UNCOMPLETED_PAYMENT: 'ALERT_UNCOMPLETED_PAYMENT'
});

export { constants };



// WEBPACK FOOTER //
// ./src/utils/constants.js